'use client';

import { createContext, useContext, useMemo } from 'react';

import type { ExperimentsProviderProps } from './use-experiments.types';

const ExperimentsContext = createContext<Record<string, string | undefined>>(
  {},
);

export const useExperiments = () => useContext(ExperimentsContext);

/**
 * Use ExperimentsProvider to provide experiment treatments down the
 * react tree to client components.
 *
 * It merges experiments from other ExperimentsProvider´s up in the components tree.
 */
export function ExperimentsProvider({
  children,
  experiments,
  // eslint-disable-next-line no-undef
}: ExperimentsProviderProps): React.ReactNode {
  const parentExperiments = useExperiments();

  const value = useMemo(
    () => ({ ...parentExperiments, ...experiments }),
    [experiments, parentExperiments],
  );

  return (
    <ExperimentsContext.Provider value={value}>
      {children}
    </ExperimentsContext.Provider>
  );
}
